import { useState } from "react";
import { toast } from "sonner";
import { LifeBuoy } from "lucide-react";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function Support() {
  const [form, setForm] = useState({ name: "", email: "", category: "Account Support", subject: "", message: "" });
  const [busy, setBusy] = useState(false);
  const [ticket, setTicket] = useState(null);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target?.value ?? e });

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const { data } = await api.post("/support/tickets", form); setTicket(data.ticket_id); toast.success("Ticket created!"); }
    catch (er) { toast.error(apiErr(er)); } finally { setBusy(false); }
  };

  if (ticket) return (
    <div className="max-w-lg mx-auto px-6 py-20 text-center">
      <LifeBuoy className="w-12 h-12 text-neon-cyan mx-auto mb-4" />
      <h1 className="font-head text-2xl font-bold">Ticket created</h1>
      <p className="text-muted-foreground mt-2">Your reference: <span className="font-mono text-neon-cyan">{ticket}</span></p>
      <p className="text-sm text-muted-foreground mt-4">Our team will get back to you soon.</p>
    </div>
  );

  return (
    <div className="max-w-xl mx-auto px-4 sm:px-6 py-14">
      <h1 className="font-head text-4xl font-black tracking-tighter mb-2">Help & Support</h1>
      <p className="text-muted-foreground mb-8">Have a question or issue? Send us a ticket.</p>
      <form onSubmit={submit} className="glass rounded-3xl p-8 space-y-5">
        <div className="grid sm:grid-cols-2 gap-4">
          <div><Label className="text-xs">Name</Label><Input required value={form.name} onChange={set("name")} className="mt-1.5 bg-input border-white/10" data-testid="sup-name" /></div>
          <div><Label className="text-xs">Email</Label><Input type="email" required value={form.email} onChange={set("email")} className="mt-1.5 bg-input border-white/10" data-testid="sup-email" /></div>
        </div>
        <div><Label className="text-xs">Category</Label>
          <Select value={form.category} onValueChange={set("category")}>
            <SelectTrigger className="bg-input border-white/10 mt-1.5" data-testid="sup-cat"><SelectValue /></SelectTrigger>
            <SelectContent className="glass border-white/10">{["Account Support", "Billing Support", "Report a Problem", "Copyright", "Other"].map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <div><Label className="text-xs">Subject</Label><Input required value={form.subject} onChange={set("subject")} className="mt-1.5 bg-input border-white/10" data-testid="sup-subject" /></div>
        <div><Label className="text-xs">Message</Label><Textarea required value={form.message} onChange={set("message")} className="mt-1.5 bg-input border-white/10 min-h-32" data-testid="sup-message" /></div>
        <Button type="submit" disabled={busy} className="w-full rounded-full bg-neon-pink hover:bg-neon-pink/90 font-bold py-6" data-testid="sup-submit">{busy ? "Sending..." : "Submit ticket"}</Button>
      </form>
    </div>
  );
}
